export default "__VITE_ASSET__CKeZkrDc__"